import Link from "next/link";

import { Auth_Nav_Actions } from "@/components/auth/auth-nav-actions";
import type { App_View } from "./types";
import { ParcelQ_Label_Mono_Class } from "./parcelq-styles";

type Header_Props = {
  View_Current: App_View;
  Account_Show?: boolean;
};

const View_Labels: Record<App_View, string> = {
  search: "Search",
  confirmation: "Parcel",
  pricing: "Reports",
  generating: "Pipeline",
  dashboard: "Dashboard",
};

export function ParcelQ_Header({ View_Current, Account_Show = true }: Header_Props) {
  return (
    <header className="border-b border-pq-border bg-pq-bg/90 px-6 py-4 backdrop-blur-md">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4">
        <div className="flex min-w-0 items-baseline gap-3">
          <Link href="/" className="font-display text-lg font-semibold tracking-tight text-pq-fg">
            ParcelQ
          </Link>
          <span className={`hidden sm:inline ${ParcelQ_Label_Mono_Class}`}>
            California parcel intelligence
          </span>
        </div>
        <div className="flex shrink-0 items-center gap-3 sm:gap-4">
          {View_Current === "dashboard" ? (
            <Link
              href="/dashboard"
              className={`${ParcelQ_Label_Mono_Class} text-amber-800 transition hover:text-amber-950 dark:text-amber-300 dark:hover:text-amber-200`}
            >
              {View_Labels[View_Current]}
            </Link>
          ) : (
            <span className={`${ParcelQ_Label_Mono_Class} text-amber-800 dark:text-amber-300`}>
              {View_Labels[View_Current]}
            </span>
          )}
          {Account_Show ? <Auth_Nav_Actions /> : null}
        </div>
      </div>
    </header>
  );
}
